// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1T4ol","loaderOuter":"PageOverlayLoader_loaderOuter__2zfOJ"};